import { render, staticRenderFns } from "./RoomTypeList.vue?vue&type=template&id=0960f21d&scoped=true"
import script from "./RoomTypeList.vue?vue&type=script&lang=js"
export * from "./RoomTypeList.vue?vue&type=script&lang=js"
import style0 from "./RoomTypeList.vue?vue&type=style&index=0&id=0960f21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960f21d",
  null
  
)

export default component.exports